import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import apiCall from "../../API/API";
import "react-toastify/dist/ReactToastify.css";
import ExportExcel from "../../Component/ExportExcel/ExportExcel";
import PaginationComponent from "../../Component/Pagination/PaginationControls";
import { toast } from "react-toastify";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import moment from "moment";
import { LuView } from "react-icons/lu";
import Popup from "reactjs-popup";
import { Carousel } from "react-bootstrap";
import { IoIosChatbubbles } from "react-icons/io";

const Support = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [tickets, setTickets] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [filterVisible, setFilterVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [search, setSearch] = useState({
    username: "",
    ticketId: "",
    status: "",
    priority: "",
    startDate: "",
    endDate: "",
  });

  const dataLimit = 20;

  const toggleFilter = () => {
    setFilterVisible(!filterVisible);
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearch((prev) => ({ ...prev, [name]: value }));
  };

  const AddFilter = () => {
    setCurrentPage(1);
    fetchData(1);
  };

  const fetchData = async (page = currentPage) => {
    try {
      const filters = Object.fromEntries(
        Object.entries(search).filter(([key, value]) => value !== "")
      );
      const queryParams = {
        page,
        limit: dataLimit,
        ...filters,
      };
      const queryString = new URLSearchParams(queryParams).toString();
      const { data, error } = await apiCall(
        "GET",
        `/get-all-tickets?${queryString}`
      );

      setTickets(data?.tickets);
      setTotalPages(data?.totalPages);
      setTotalRecords(data?.totalRecords);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const ResetFun = async () => {
    const resetState = {
      username: "",
      ticketId: "",
      status: "",
      priority: "",
      startDate: "",
      endDate: "",
    };

    setSearch(resetState);

    const queryParams = {
      page: 1,
      limit: dataLimit,
    };
    const queryString = new URLSearchParams(queryParams).toString();

    try {
      const { data } = await apiCall(
        "GET",
        `/get-all-tickets?${queryString}`,
        null,
        false
      );
      setTickets(data?.tickets);
      setTotalPages(data?.totalPages);
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const updateStatus = async (ticketId, newStatus) => {
    const queryParams = {
      ticketId: ticketId,
    };
    const queryString = new URLSearchParams(queryParams).toString();
    try {
      const response = await apiCall("POST", `/update-ticket?${queryString}`, {
        status: newStatus,
      });
      console.log(response, "jjjjjjjjjjj");

      if (response?.data) {
        toast.success(
          response?.data?.message || "Ticket status updated successfully."
        );
        // Optionally, you can refetch the data or update the state here to reflect the changes immediately
        fetchData(); // This will fetch the updated ticket list
      } else {
        toast.error("Failed to update ticket status.");
      }
    } catch (error) {
      console.error("Error updating ticket status:", error);
      toast.error("An error occurred while updating the status.");
    }
  };

  return (
    <React.Fragment>
      <Container>
        <div className="pagePath">
          <h4 className="m-0">Home/Support</h4>
          <div></div>
        </div>

        <Row id="filterRow">
          <span id="filterLogo">
            <div className="d-flex justify-content-between">
              <div onClick={toggleFilter}>
                <i>
                  <BiFilter />
                </i>
                Filter
              </div>
            </div>
          </span>

          {filterVisible && (
            <Row className="p-0 m-0">
              {/* <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="username"
                    placeholder="Search By Username"
                    value={search.username}
                    onChange={handleChange}
                  />
                </div>
              </Col> */}

              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="ticketId"
                    placeholder="Search By Ticket Id"
                    value={search.ticketId}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="status"
                    placeholder="Search By Status"
                    value={search.status}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="text"
                    name="priority"
                    placeholder="Search By Priority"
                    value={search.priority}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="date"
                    name="startDate"
                    placeholder="Search By Start date"
                    value={search.startDate}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col lg="2" md="4">
                <div>
                  <input
                    type="date"
                    name="endDate"
                    placeholder="Search By End date"
                    value={search.endDate}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <div>
                <button className="save filter" onClick={AddFilter}>
                  Filter{" "}
                  <i>
                    <BiFilter />
                  </i>
                </button>
                <button className="cancel reset" onClick={ResetFun}>
                  Reset{" "}
                  <i>
                    <GrPowerReset />
                  </i>
                </button>
              </div>
            </Row>
          )}
        </Row>

        <Row id="directTableRow">
          <Col md="12" className="p-0">
            <div style={{ width: "100%" }}>
              <table>
                <tr>
                  <th>S No.</th>
                  <th>Name</th>
                  <th>Username</th>
                  <th>Ticket Id</th>
                  <th>Subject</th>
                  <th>Description</th>
                  <th>Attachments</th>
                  <th>Status</th>
                  <th>Priority</th>
                  <th>Chat</th>
                  <th>Date</th>
                </tr>

                {tickets?.map((x, i) => {
                  return (
                    <tr key={i}>
                      <td>{i + 1 + dataLimit * (currentPage - 1)}</td>
                      <td>{x?.name}</td>
                      <td>{x?.username}</td>
                      <td>{x?.ticketId}</td>
                      <td>{x?.subject}</td>
                      <td>{x?.description}</td>
                      <td style={{ textAlign: "center" }}>
                        {/* Popup for attachments */}
                        <Popup
                          trigger={
                            <button className="block-btn">
                              <LuView />
                            </button>
                          }
                          modal
                          closeOnDocumentClick
                          className="popup-box"
                        >
                          {(close) => (
                            <div className="popup-contentNews">
                              <button className="close-btn" onClick={close}>
                                &times;
                              </button>
                              {/* Attachments carousel */}
                              {x?.attachments?.length > 1 ? (
                                <Carousel>
                                  {x?.attachments?.map((row, index) => (
                                    <Carousel.Item key={index}>
                                      <div
                                        className="carousel-content"
                                        style={{ textAlign: "center" }}
                                      >
                                        <img
                                          src={row}
                                          alt={`attachment-${index}`}
                                          className="popImg"
                                        />
                                      </div>
                                    </Carousel.Item>
                                  ))}
                                </Carousel>
                              ) : (
                                <img
                                  src={x?.attachments[0]}
                                  alt="attachment"
                                  className="popImg"
                                />
                              )}
                            </div>
                          )}
                        </Popup>
                      </td>

                      <td>
                        <select
                          value={x?.status}
                          onChange={(e) =>
                            updateStatus(x?.ticketId, e.target.value)
                          }
                          style={{
                            background: "#153D77 !important",
                            borderRadius: "5px",
                          }}
                        >
                          <option value="Open">Open</option>
                          {/* <option value="In Progress">In Progress</option> */}
                          <option value="Closed">Closed</option>
                        </select>
                      </td>

                      <td>{x?.priority}</td>

                      <td style={{ textAlign: "center" }}>
                        <button
                          className="block-btn"
                          onClick={() =>
                            navigate(`/dashboard/chat`, {
                              state: {
                                ticketid: x?.ticketId,
                              },
                            })
                          }
                        >
                          <IoIosChatbubbles />
                        </button>
                      </td>

                      <td>
                        {moment(x?.created_at).format("DD-MM-YYYY   &   HH:mm")}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            {
              <PaginationComponent
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePagination}
              />
            }
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Support;
